import Explorer from './Explorer';
import MonthVerse from './MonthVerse';
import Direction from './Direction';
import Service from './Service';
import { Wrapper } from '../Style';

function Home() {
  return (
    <Wrapper>
      {/* <Explorer /> */}
      {/* <MonthVerse /> */}
      <Service />
      <Direction />
    </Wrapper>
  );
}

export default Home;
